import Vue from 'vue';
import VueI18n from 'vue-i18n';

import locale from 'element-ui/lib/locale';
import zh from './lang/zh';
import en from './lang/en';
import vi from './lang/vi';
import enLocale from 'element-ui/lib/locale/lang/en';
import viLocale from 'element-ui/lib/locale/lang/vi';
import zhLocale from 'element-ui/lib/locale/lang/zh-CN';
import moment from 'moment';

// 配置语言切换
Vue.use(VueI18n);

export const defaultLang = 'vi';

const messages = {
  zh: Object.assign(zh, zhLocale),
  en: Object.assign(en, enLocale),
  vi: Object.assign(vi, viLocale)
};

const i18n = new VueI18n({
  silentTranslationWarn: true,
  locale: defaultLang,
  fallbackLocale: defaultLang,
  messages
});
locale.i18n((key, value) => i18n.t(key, value)); //为了实现element插件的多语言切换

function setI18nLanguage(lang) {
  i18n.locale = lang;
  document.querySelector('html').setAttribute('lang', lang);
  return lang;
}

export function loadLanguageAsync(lang = defaultLang) {
  return new Promise((resolve) => {
    if (i18n.locale !== lang) {
      const locale = messages[lang];
      moment.updateLocale(locale.momentName, locale.momentLocale);
      return resolve(setI18nLanguage(lang));
    }
    return resolve(lang);
  });
}

export default i18n;



// WEBPACK FOOTER //
// ./src/i18n/index.js